<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="compare-card" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.sjxz')">
              <el-button-group>
                <el-button :type="active === 'month' ? 'primary' : ''" @click="activeChange('month', 'yyyy-MM', 'dd')">{{
                  $t('text.y') }}</el-button>
                <el-button :type="active === 'year' ? 'primary' : ''" @click="activeChange('year', 'yyyy', 'MM')">{{
                  $t('text.n') }}</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item :label="$t('text.sbsn')">
              <el-select v-model="device.id" placeholder="" @change="GetCompareDatas(device.id)">
                <el-option v-for="item in devicelist" :key="item.id" :label="item.key" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('text.rq')">
              <el-date-picker
                v-show="active === 'month'"
                v-model="selectTime"
                style="margin-top: 0;"
                type="month"
                :placeholder="$t('text.xzy')"
                @keyup.enter.native="handleQuery"
              />
              <el-date-picker
                v-show="active === 'year'"
                v-model="selectTime"
                style="margin-top: 0;"
                type="year"
                :placeholder="$t('text.xzn')"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                style="background:#175E77;border:none"
                @click="GetCompareDatas(device.id)"
              >{{ $t('button.cx') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <div class="chart-container">
            <div class="item-chart">
              <h1 class="chart-title">正向电量</h1>
              <histogam-chart
                class="chart-content"
                :data="chart.data"
                :columns="chart.fcolumns"
                :setting="chart.fsetting"
                :extend="chart.extend"
                unit="KWh"
              />
            </div>
            <div class="item-chart">
              <h1 class="chart-title">反向电量</h1>
              <histogam-chart
                class="chart-content"
                :data="chart.data"
                :columns="chart.rcolumns"
                :setting="chart.rsetting"
                :extend="chart.extend"
                unit="KWh"
              />
            </div>
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
import { GetEnergyCompareData } from '@/api/Meter'
import { GetDevicesByOrgId } from '@/api/Universal'
import HistogamChart from '@/components/Charts/HistogramChart.vue'
export default {
  name: 'CompareContent',
  components: {
    HistogamChart
  },
  data () {
    return {
      meter: [
        { value: '2', label: 'text.zxdl' },
        { value: '1', label: 'text.fxdl' }
      ],
      select: false,
      value: '',
      selectTime: this.$parseTime(new Date(), 'yyyy-MM-dd'),
      format: 'yyyy-MM-dd',
      active: 'month',
      chartLoading: false,
      tablist: [],
      device: {},
      devicelist: [],
      chart: {
        fsetting: {
          labelMap: {
            fsharp: this.$t('text.j'),
            fpeak: this.$t('text.f'),
            fflat: this.$t('text.p'),
            fvalley: this.$t('text.g'),
            ftotal: this.$t('text.z1')
          }
        },
        data: [],
        extend: {
          legend: {
            textStyle: {
              color: '#fff'
            }
          },
          color: ['#FF6464', '#649DFF', '#98E553', '#FFBD49', '#C453E5'],
          yAxis: {
            name: 'KWh',
            position: 'left'
          },
          textStyle: {
            color: '#fff'
          }
        },
        fcolumns: ['sitetime', 'fsharp', 'fpeak', 'fflat', 'fvalley', 'ftotal'],
        rsetting: {
          labelMap: {
            rsharp: this.$t('text.j'),
            rpeak: this.$t('text.f'),
            rflat: this.$t('text.p'),
            rvalley: this.$t('text.g'),
            rtotal: this.$t('text.z1')
          }
        },
        rcolumns: ['sitetime', 'rsharp', 'rpeak', 'rflat', 'rvalley', 'rtotal']
      },
    }
  },
  mounted () {
    this.getDeviceList(() => {
      this.GetCompareDatas()
    })
    this.activeChange('month', 'yyyy-MM', 'dd')
  },
  methods: {
    getDeviceList (callback) {
      GetDevicesByOrgId({ id: this.$store.getters.station.id, tag: '3' })
        .then(res => {
          this.devicelist = res.data || []
          this.select = true
          this.device.id = this.devicelist[0].value || null
          if (callback) {
            callback()
          }
        })
    },
    GetCompareDatas () {
      let st, et
      if (this.active === 'month') {
        st = this.$parseTime(this.selectTime, this.format) + '-01 00:00:00'
        et = this.$parseTime(this.selectTime, this.format) +
          `-${this.$gmt(this.selectTime)} 23:59:59`
      } else if (this.active === 'year') {
        st = this.$parseTime(this.selectTime, this.format) + '-01-01 00:00:00'
        et = this.$parseTime(this.selectTime, this.format) + '-12-31 23:59:59'
      }
      if (this.device.id) {
        GetEnergyCompareData({
          dateType: this.active,
          startTime: st,
          endTime: et,
          deviceId: this.device.id
        }).then(res => {
          this.chart.data = res.data || []
          this.tablist = []
          if (!res.data) return
          res.data.map(o => {
            o.sitetime = this.$parseTime(o.sitetime, 'yyyy-MM-dd')
          })
        })
      }
    },
    handleQuery () {
      this.GetCompareDatas(this.device.id)
    },
    activeChange (active, format, chartFormat) {
      this.active = active
      this.format = format
      this.chartFormat = chartFormat
    },
    formatTime (row, column, cellValue, index) {
      return this.$parseTime(cellValue, 'yyyy-MM-dd')
    }
  }
}
</script>
<style scoped>
.compare-card {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.compare-card>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.compare-card >>> .el-card__header .el-form{
  width: 100%;
  height: 50px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.compare-card>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.compare-card>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
.compare-card>>> .el-card__body .chart-container{
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  display:grid;
  grid-template-rows: 1fr 1fr;
  grid-gap: 20px;
}
.compare-card>>> .el-card__body .chart-container .item-chart{
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
}
.compare-card>>> .el-card__body .chart-container .item-chart .chart-title{
  width: 100%;
  height: 40px;
  font-weight: bold;
  color: var(--primary-color);
  padding-left:11px;
}
.compare-card>>> .el-card__body .chart-container .item-chart .chart-content{
  width: 100%;
  height: calc(100% - 40px);
  padding: 0px;
  box-sizing: border-box;
}

</style>
